var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEmailRequired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6484 4.96484C16.8398 5.59766 15.8203 6.37109 12.2344 8.97266C11.5312 9.5 10.2305 10.6602 9 10.6602C7.73438 10.6602 6.46875 9.5 5.73047 8.97266C2.14453 6.37109 1.125 5.59766 0.316406 4.96484C0.175781 4.85938 0 4.96484 0 5.14062V12.3125C0 13.2617 0.738281 14 1.6875 14H16.3125C17.2266 14 18 13.2617 18 12.3125V5.14062C18 4.96484 17.7891 4.85938 17.6484 4.96484ZM9 9.5C9.80859 9.53516 10.9688 8.48047 11.5664 8.05859C16.2422 4.68359 16.5938 4.36719 17.6484 3.52344C17.8594 3.38281 18 3.13672 18 2.85547V2.1875C18 1.27344 17.2266 0.5 16.3125 0.5H1.6875C0.738281 0.5 0 1.27344 0 2.1875V2.85547C0 3.13672 0.105469 3.38281 0.316406 3.52344C1.37109 4.36719 1.72266 4.68359 6.39844 8.05859C6.99609 8.48047 8.15625 9.53516 9 9.5Z",
    fill: "#F72C40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmailRequired);
export default __webpack_public_path__ + "static/media/ic-email-required.af42efcefa460483f838ae0049640de8.svg";
export { ForwardRef as ReactComponent };